import ApplicationController from '../application_controller';
import Overlay from '../../../../libs/cifra/overlay';

/* global $ */
export default class extends ApplicationController {
  connect() {
    this.initCuadernosView();
    this.lanzarEventoCargado();
  }

  initCuadernosView() {
    const el = this.element;
    const $el = $(el);

    // Submit form handler
    el.querySelectorAll('form.grupo').forEach((form) => {
      form.addEventListener('submit', () => {
        this.overlay = new Overlay(document.querySelector('.wrapper-content'), { position: 'top' });
        this.overlay.show();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });

    document.addEventListener('turbo:submit-end', (_event) => {
      if (this.overlay) {
        this.overlay.hide();
        this.overlay = null;
      }
    });

    // Focus handler for .horas-refuerzo
    el.querySelectorAll('.horas-refuerzo').forEach((input) => {
      input.addEventListener('focus', (e) => {
        e.currentTarget.select();
      });
    });

    // Prevent enter key in .horas-refuerzo inputs
    el.querySelectorAll('form input.horas-refuerzo').forEach((input) => {
      input.addEventListener('keypress', (e) => {
        if (e.keyCode === 13) {
          e.preventDefault();
        }
      });
    });

    $el.find('.pastilla-profesor').draggable({
      revert: 'invalid',
      cursor: 'move',
      helper: 'clone',
      zIndex: 100,
    });

    $el.find('.profesores-libres, .profesores-titulares, .profesores-refuerzo').droppable({
      activeClass: 'droppable-hover',
      accept(draggable) {
        const $dest = $(this);
        if (draggable.data('asignatura-id') !== $dest.data('asignatura-id')) {
          return false;
        }
        return true;
      },
      drop(_event, ui) {
        const $destino = $(this);
        const $inputHoras = ui.draggable.find('.horas-refuerzo');
        const tipo = $destino.data('tipo');
        if (tipo === 'refuerzo') {
          if (!$inputHoras.val()) {
            $inputHoras.val(0);
          }
          $inputHoras.removeClass('hide').select();
        } else {
          $inputHoras.addClass('hide');
        }
        ui.draggable.find('input.cuaderno_profesor_tipo').val(tipo);
        $(this).append(ui.draggable);
        $inputHoras.focus();
      },
    });
  }
}
